import { supabase } from '@/shared/lib/supabase';
import { logger } from '@/shared/lib/logger';
import {
  releaseSchema,
  systemMessageSchema,
  type Release,
  type SystemMessage,
} from '@shared/schemas/releases';

export const releasesKeys = {
  all: ['releases'] as const,
  current: () => [...releasesKeys.all, 'current'] as const,
  systemMessages: () => ['system_messages', 'active'] as const,
};

export async function fetchCurrentRelease(): Promise<Release | null> {
  const { data, error } = await supabase
    .from('releases')
    .select('*')
    .not('published_at', 'is', null)
    .lte('published_at', new Date().toISOString())
    .order('published_at', { ascending: false })
    .limit(1)
    .maybeSingle();
  if (error) {
    logger.error('fetchCurrentRelease failed', { code: error.code });
    return null;
  }
  return data ? releaseSchema.parse(data) : null;
}

export async function fetchActiveSystemMessages(): Promise<SystemMessage[]> {
  const { data, error } = await supabase
    .from('system_messages')
    .select('*')
    .order('active_from', { ascending: false });
  if (error) {
    logger.error('fetchActiveSystemMessages failed', { code: error.code });
    return [];
  }
  return (data ?? []).map((row) => systemMessageSchema.parse(row));
}
